export default __webpack_public_path__ + "static/media/ear.e04b9155.png";